"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _jsxRuntime = require("@emotion/react/jsx-runtime");

var _presets = require("@zip/theme/dist/presets");

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

var ZipLogoMark = function ZipLogoMark(_ref) {
  var _ref$theme = _ref.theme,
      theme = _ref$theme === void 0 ? _presets.fearless : _ref$theme,
      _ref$variant = _ref.variant,
      variant = _ref$variant === void 0 ? 'primary' : _ref$variant,
      _ref$shape = _ref.shape,
      shape = _ref$shape === void 0 ? 'square' : _ref$shape,
      _ref$fill = _ref.fill,
      fill = _ref$fill === void 0 ? 'none' : _ref$fill,
      props = _objectWithoutProperties(_ref, ["theme", "variant", "shape", "fill"]);

  var variantMappings = {
    primary: {
      background: theme.colors.primary.main,
      foreground: theme.colors.secondary
    },
    dark: {
      background: theme.colors.secondary,
      foreground: theme.colors.muted
    },
    light: {
      background: theme.colors.muted,
      foreground: theme.colors.primary.main
    }
  };
  return (0, _jsxRuntime.jsxs)("svg", _objectSpread(_objectSpread({
    width: "184",
    height: "184",
    viewBox: "0 0 184 184",
    fill: fill
  }, props), {}, {
    children: [shape === 'square' && (0, _jsxRuntime.jsxs)(_jsxRuntime.Fragment, {
      children: [(0, _jsxRuntime.jsx)("path", {
        d: "M184 0H0V184H184V0Z",
        fill: variantMappings[variant].background
      }), (0, _jsxRuntime.jsx)("path", {
        d: "M40.8393 111.079L43.8598 135.203H150.421L146.993 107.591H97.2545L96.8868 104.213L142.631 73.1737L139.571 49H33L36.4378 76.6015H86.2556L86.6828 80.0393L40.8393 111.079Z",
        fill: variantMappings[variant].foreground
      })]
    }), shape === 'circle' && (0, _jsxRuntime.jsxs)(_jsxRuntime.Fragment, {
      children: [(0, _jsxRuntime.jsx)("path", {
        d: "M184 91.9809C184.004 110.178 178.611 127.968 168.503 143.101C158.396 158.233 144.027 170.028 127.216 176.993C110.404 183.959 91.9044 185.782 74.0564 182.233C56.2084 178.684 39.8137 169.921 26.9461 157.054C14.0786 144.186 5.31611 127.792 1.76687 109.944C-1.78236 92.0956 0.0411265 73.5959 7.00675 56.7843C13.9724 39.9727 25.7673 25.6045 40.8995 15.4969C56.0317 5.38921 73.8216 -0.00376719 92.0191 1.97435e-06C116.413 0.00252868 139.807 9.69416 157.057 26.9434C174.306 44.1926 183.997 67.5868 184 91.9809Z",
        fill: variantMappings[variant].background
      }), (0, _jsxRuntime.jsx)("path", {
        d: "M48.7776 108.132L51.3598 128.571H141.95L138.967 105.15H96.7261L96.3927 102.262L135.26 75.8583L132.64 55.381H42.1169L45.0613 78.8027H87.3404L87.7405 81.7185L48.7776 108.132Z",
        fill: variantMappings[variant].foreground
      })]
    })]
  }));
};

var _default = ZipLogoMark;
exports["default"] = _default;